export const SET_COUNTRIES_LIST = 'SET_COUNTRIES_LIST'
export const CLEAR_DATA = 'CLEAR_DATA'
export const STORE_FAQ = 'STORE_FAQ'
export const STORE_PAGINATION = 'STORE_PAGINATION'
export const STORE_META = 'STORE_META'
export const STORE_TESTIMONIAL = 'STORE_TESTIMONIAL'
export const STORE_BREADCRUMB = 'STORE_BREADCRUMB'
export const STORE_INTERNAL_LINKS = 'STORE_INTERNAL_LINKS'
